<template>
  <div
    class="relative flex items-center w-full cursor-pointer"
    :class="[
      classes,
      hasIcon ? 'px-4 py-3' : 'px-4 py-5',
      borderless ? '!border-0' : '',
      hasOnlyBorderTop
        ? 'border-t border-light-gray'
        : 'border-t border-b border-light-gray',
      hideBorderTopMobile ? 'border-t-0 md:border-t' : '',
    ]"
    role="button"
    tabindex="0"
  >
    <div v-if="icon" class="flex-shrink-0 mr-4">
      <component :is="icon" class="w-6 h-6" />
    </div>
    <div class="flex-1 text-lg">
      {{ label }}
    </div>
    <div v-if="hasIcon" class="flex-shrink-0 ml-4">
      <div
        class="w-10 h-10 rounded-full bg-white flex items-center justify-center"
      >
        <ArrowRightIcon class="w-6 h-6" />
      </div>
    </div>
    <div v-if="hasToggle" class="flex-shrink-0 ml-4">
      <div class="flex items-center justify-center">
        <slot name="toggle"></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ArrowRightIcon from "../../v2/icon/ArrowRightIcon.vue";

defineProps<{
  label: string;
  icon?: any;
  classes?: string;
  borderless?: boolean;
  hasOnlyBorderTop?: boolean;
  hasIcon?: boolean;
  hideBorderTopMobile?: boolean;
  hasToggle?: boolean;
}>();
</script>
